/**
 * Lifestyle Slider
 * @requires https://swiperjs.com/
 */

export default (() => {
  /* eslint-disable no-undef, no-unused-vars  */

  // Get total number of slides (real slides, not including loop duplicates)
  const getTotalSlides = () => {
    return document.querySelectorAll(
      '#lifestyle-slider-content .swiper-slide:not(.swiper-slide-duplicate)'
    ).length
  }

  // Create custom pagination
  const createPagination = () => {
    const container = document.querySelector('#lifestyle-slider-pagination')
    if (!container) return

    const total = getTotalSlides()
    container.innerHTML = ''

    for (let i = 0; i < total; i++) {
      const bullet = document.createElement('div')
      bullet.className =
        'group relative size-12 sm:size-13 md:size-14.5 cursor-pointer transition-opacity duration-300 opacity-60 hover:opacity-100 [&.active]:opacity-100'
      bullet.dataset.index = i

      // Background circle
      const bg = document.createElement('div')
      bg.className =
        'absolute inset-0 rounded-full bg-white/12 border border-white/24 backdrop-blur-lg transition-opacity duration-300 opacity-0 group-[.active]:opacity-100'

      // Progress SVG
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
      svg.setAttribute('class', 'absolute inset-0 -rotate-90')
      svg.setAttribute('viewBox', '0 0 60 60')

      const circle = document.createElementNS(
        'http://www.w3.org/2000/svg',
        'circle'
      )
      circle.setAttribute('cx', '30')
      circle.setAttribute('cy', '30')
      circle.setAttribute('r', '28')
      circle.setAttribute('class', 'fill-none stroke-white/80 stroke-2')
      circle.style.strokeDasharray = '176'
      circle.style.strokeDashoffset = '176'
      circle.style.transition = 'none'

      svg.appendChild(circle)

      // Number
      const number = document.createElement('div')
      number.className =
        'absolute inset-0 flex items-center justify-center font-heading text-xl/6 md:text-[1.375rem]/7 lg:text-2xl/7.5 xl:text-[1.625rem]/8 text-white'
      number.textContent = String(i + 1).padStart(2, '0')

      bullet.appendChild(bg)
      bullet.appendChild(svg)
      bullet.appendChild(number)

      bullet.addEventListener('click', () => {
        contentSlider.slideToLoop(i)
      })

      container.appendChild(bullet)
    }
  }

  // Update pagination active state
  const updatePagination = (realIndex) => {
    const bullets = document.querySelectorAll(
      '#lifestyle-slider-pagination > div'
    )
    bullets.forEach((bullet, index) => {
      const circle = bullet.querySelector('circle')

      if (index === realIndex) {
        bullet.classList.add('active')

        // Reset and restart animation
        circle.style.strokeDashoffset = '176'
        circle.style.transition = 'none'
        void circle.offsetWidth // Trigger reflow
        circle.style.transition = 'stroke-dashoffset 8s linear'
        circle.style.strokeDashoffset = '0'
      } else {
        bullet.classList.remove('active')

        // Reset progress
        circle.style.transition = 'none'
        circle.style.strokeDashoffset = '176'
      }
    })
  }

  // Init
  const contentSlider = new Swiper('#lifestyle-slider-content', {
    effect: 'fade',
    fadeEffect: { crossFade: true },
    allowTouchMove: false,
    loop: true,
    autoplay: {
      delay: 8000,
      disableOnInteraction: false,
    },
    on: {
      init: function () {
        createPagination()
        requestAnimationFrame(() => {
          updatePagination(this.realIndex)
        })
      },
      slideChange: function () {
        updatePagination(this.realIndex)
      },
      slideChangeTransitionStart: function () {
        // Add ken-burns class to the bg slider's active slide image
        const bgActiveSlide = bgImageSlider.slides[bgImageSlider.activeIndex]
        const bgActiveImg = bgActiveSlide?.querySelector('img')
        if (bgActiveImg) {
          bgActiveImg.classList.add('ken-burns')
        }
      },
      slideChangeTransitionEnd: function () {
        // Remove ken-burns class from all non-active slides after transition completes
        setTimeout(() => {
          bgImageSlider.slides.forEach((slide, index) => {
            if (index !== bgImageSlider.activeIndex) {
              const img = slide.querySelector('img')
              if (img) {
                img.classList.remove('ken-burns')
              }
            }
          })
        }, 100)
      },
    },
  })

  const fgImageSlider = new Swiper('#lifestyle-slider-fg-images', {
    effect: 'flip',
    flipEffect: {
      slideShadows: false,
    },
    allowTouchMove: false,
    loop: true,
    speed: 500,
  })

  const bgImageSlider = new Swiper('#lifestyle-slider-bg-images', {
    effect: 'fade',
    allowTouchMove: false,
    loop: true,
    speed: 500,
  })

  // Sync sliders
  contentSlider.controller.control = [fgImageSlider, bgImageSlider]

  // Observer for Playback Control
  const sliderWrapper = document.querySelector('#about')

  const sliderObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!contentSlider || !contentSlider.autoplay) return

        if (entry.isIntersecting) {
          // In-View Logic:
          // Reset to the first slide (index 0) instantly so story starts from beginning.
          // Using speed 0 to prevent visual transition.
          contentSlider.slideToLoop(0, 0)

          // Manually trigger pagination update to restart the progress bar animation.
          // Note the use index -1 to reset all bullets,
          // because the pagination animation not depends on slider autoplay,
          // but added through css transition.
          updatePagination(-1)

          // Finally, start autoplay
          contentSlider.autoplay.start()
        } else {
          // Out-of-View Logic:
          // Reset to the first slide so it is ready for the next viewing.
          contentSlider.slideToLoop(0, 0)

          // Stop autoplay immediately
          contentSlider.autoplay.stop()
        }
      })
    },
    { threshold: 0.3 } // Trigger when 30% of the section is visible.
  )

  if (sliderWrapper) sliderObserver.observe(sliderWrapper)

  /* eslint-enable no-undef, no-unused-vars  */
})()
